import { createContext } from "react";
import { OrganizationDto } from "./Organization";

export type OrganizationContextType = {
  organization: OrganizationDto;
};

export const OrganizationContext = createContext<OrganizationContextType>(
  undefined as unknown as OrganizationContextType
);
